import React from 'react';
import { Link } from 'react-router-dom';

function Service() {
    const ChangePageTitle = (pageTitle) => {
        document.title = pageTitle;
    };
    ChangePageTitle('Portfolio - Services');
    return (
        <section className="service-area">
            <div className="container">
                <div
                    data-elementor-type="wp-page"
                    data-elementor-id="1119"
                    className="elementor elementor-1119"
                >
                    <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-c057728 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="c057728"
                        data-element_type="section"
                    >
                        <div className="elementor-container elementor-column-gap-default">
                            <div
                                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-5690479"
                                data-id="5690479"
                                data-element_type="column"
                            >
                                <div className="elementor-widget-wrap elementor-element-populated">
                                    <section
                                        className="elementor-section elementor-inner-section elementor-element elementor-element-44fca9a elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                        data-id="44fca9a"
                                        data-element_type="section"
                                    >
                                        <div className="elementor-container elementor-column-gap-default">
                                            <div
                                                className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-7a7fa3f"
                                                data-id="7a7fa3f"
                                                data-element_type="column"
                                            >
                                                <div className="elementor-widget-wrap elementor-element-populated">
                                                    <div
                                                        className="elementor-element elementor-element-4635d00 h-100 elementor-widget elementor-widget-gridxdaservicesidebar"
                                                        data-id="4635d00"
                                                        data-element_type="widget"
                                                        data-widget_type="gridxdaservicesidebar.default"
                                                    >
                                                        <div className="elementor-widget-container">
                                                            <div
                                                                className="service-sidebar"
                                                                data-aos="fade-right"
                                                            >
                                                                <div className="service-sidebar-inner shadow-box">
                                                                    <ul>
                                                                        <li>
                                                                            <i className="iconoir-code icon"></i>
                                                                            Web
                                                                            Development{' '}
                                                                        </li>
                                                                        <li>
                                                                            <i className="iconoir-search icon"></i>
                                                                            SEO
                                                                            Optimization{' '}
                                                                        </li>
                                                                        <li>
                                                                            <i className="iconoir-accessibility icon"></i>
                                                                            Accessibility
                                                                            Strategy{' '}
                                                                        </li>
                                                                        <li>
                                                                            <i className="iconoir-computer icon"></i>
                                                                            IT &
                                                                            Technology{' '}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-b02c996"
                                                data-id="b02c996"
                                                data-element_type="column"
                                            >
                                                <div className="elementor-widget-wrap elementor-element-populated">
                                                    <div
                                                        className="elementor-element elementor-element-ad8c673 elementor-widget elementor-widget-gridxdaservicecontentbox"
                                                        data-id="ad8c673"
                                                        data-element_type="widget"
                                                        data-widget_type="gridxdaservicecontentbox.default"
                                                    >
                                                        <div className="elementor-widget-container">
                                                            <h1
                                                                className="section-heading"
                                                                data-aos="fade-up"
                                                            >
                                                                <img
                                                                    decoding="async"
                                                                    src="/assets/images/star-2-2.png"
                                                                    alt="Star"
                                                                />
                                                                My Offerings
                                                                <img
                                                                    decoding="async"
                                                                    src="/assets/images/star-2-2.png"
                                                                    alt="Star"
                                                                />
                                                            </h1>

                                                            <div
                                                                className="service-content-wrap"
                                                                data-aos="zoom-in"
                                                            >
                                                                <div className="service-content-inner shadow-box">
                                                                    <div className="service-items">
                                                                        <div className="service-item">
                                                                            <h3>
                                                                                Web
                                                                                Development
                                                                            </h3>
                                                                            In
                                                                            addition
                                                                            to
                                                                            my
                                                                            prowess
                                                                            in
                                                                            backend
                                                                            website
                                                                            development,
                                                                            I
                                                                            possess
                                                                            a
                                                                            wealth
                                                                            of
                                                                            expertise
                                                                            when
                                                                            it
                                                                            comes
                                                                            to
                                                                            frontend
                                                                            web
                                                                            development.
                                                                            My
                                                                            journey
                                                                            encompasses
                                                                            crafting
                                                                            elegant
                                                                            and
                                                                            responsive
                                                                            user
                                                                            interfaces
                                                                            .{' '}
                                                                        </div>
                                                                        <div className="service-item">
                                                                            <h3>
                                                                                SEO
                                                                                Optimization
                                                                            </h3>
                                                                            Furthermore,
                                                                            my
                                                                            skill
                                                                            set
                                                                            extends
                                                                            beyond
                                                                            development
                                                                            as I
                                                                            hold
                                                                            a
                                                                            firm
                                                                            grasp
                                                                            of
                                                                            SEO
                                                                            optimization
                                                                            concepts.
                                                                            Leveraging
                                                                            this
                                                                            knowledge,
                                                                            I
                                                                            ensure
                                                                            that
                                                                            the
                                                                            web
                                                                            applications
                                                                            I
                                                                            craft
                                                                            are
                                                                            not
                                                                            only
                                                                            visually
                                                                            captivating
                                                                            but
                                                                            also
                                                                            highly
                                                                            discoverable
                                                                            by
                                                                            search
                                                                            engines.{' '}
                                                                        </div>
                                                                        <div className="service-item">
                                                                            <h3>
                                                                                Accessibility
                                                                                Strategy
                                                                            </h3>
                                                                            Moreover,
                                                                            I
                                                                            take
                                                                            pride
                                                                            in
                                                                            my
                                                                            dedication
                                                                            to
                                                                            accessibility.
                                                                            I
                                                                            possess
                                                                            the
                                                                            knowledge
                                                                            and
                                                                            expertise
                                                                            to
                                                                            ensure
                                                                            that
                                                                            websites
                                                                            I
                                                                            develop
                                                                            are
                                                                            accessible
                                                                            to
                                                                            disabled
                                                                            individuals,
                                                                            allowing
                                                                            them
                                                                            to
                                                                            fully
                                                                            engage
                                                                            with
                                                                            and
                                                                            navigate
                                                                            through
                                                                            the
                                                                            digital
                                                                            landscape.{' '}
                                                                        </div>
                                                                        <div className="service-item">
                                                                            <h3>
                                                                                IT
                                                                                &
                                                                                Technology
                                                                            </h3>
                                                                            Beyond
                                                                            my
                                                                            IT
                                                                            background,
                                                                            I've
                                                                            also
                                                                            immersed
                                                                            myself
                                                                            in
                                                                            the
                                                                            technology
                                                                            sector,
                                                                            gaining
                                                                            valuable
                                                                            insights
                                                                            and
                                                                            hands-on
                                                                            experience.
                                                                            Furthermore,
                                                                            my
                                                                            journey
                                                                            has
                                                                            led
                                                                            me
                                                                            to
                                                                            work
                                                                            extensively
                                                                            in
                                                                            the
                                                                            IT
                                                                            and
                                                                            technology
                                                                            industry.{' '}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-d3ed86a elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="d3ed86a"
                        data-element_type="section"
                    >
                        <div className="elementor-container elementor-column-gap-default">
                            <div
                                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-73c83d4"
                                data-id="73c83d4"
                                data-element_type="column"
                            >
                                <div className="elementor-widget-wrap elementor-element-populated">
                                    <section
                                        className="elementor-section elementor-inner-section elementor-element elementor-element-e33f508 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                        data-id="e33f508"
                                        data-element_type="section"
                                    >
                                        <div className="elementor-container elementor-column-gap-default">
                                            <div
                                                className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-822f062"
                                                data-id="822f062"
                                                data-element_type="column"
                                            >
                                                <div className="elementor-widget-wrap elementor-element-populated">
                                                    <div
                                                        className="elementor-element elementor-element-031f9cc elementor-widget elementor-widget-gridxdaprofilesbox"
                                                        data-id="031f9cc"
                                                        data-element_type="widget"
                                                        data-widget_type="gridxdaprofilesbox.default"
                                                    >
                                                        <div className="elementor-widget-container">
                                                            <div className="col-md-12">
                                                                <div className="blog-service-profile-wrap">
                                                                    <div
                                                                        data-aos="zoom-in"
                                                                        className="about-profile-box-wrap"
                                                                    >
                                                                        <div className="about-profile-box info-box shadow-box h-full">
                                                                            <div className="inner-profile-icons shadow-box">
                                                                                <Link to="https://github.com/PankajBaliyan">
                                                                                    <i className="iconoir-github"></i>
                                                                                </Link>

                                                                                <Link to="https://www.linkedin.com/in/pankaj-kumar-90/">
                                                                                    <i className="iconoir-linkedin"></i>
                                                                                </Link>
                                                                            </div>
                                                                            <div className="d-flex align-items-center justify-content-between">
                                                                                <div className="infos">
                                                                                    <h4>
                                                                                        STAY
                                                                                        WITH
                                                                                        ME
                                                                                    </h4>
                                                                                    <h1>
                                                                                        Profiles
                                                                                    </h1>
                                                                                </div>

                                                                                <Link
                                                                                    to="/contact"
                                                                                    className="about-btn"
                                                                                >
                                                                                    <img
                                                                                        decoding="async"
                                                                                        src="/assets/images/icon-2.svg"
                                                                                        alt="Button"
                                                                                    />
                                                                                </Link>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-e325eec"
                                                data-id="e325eec"
                                                data-element_type="column"
                                            >
                                                <div className="elementor-widget-wrap elementor-element-populated">
                                                    <div
                                                        className="elementor-element elementor-element-983e78f elementor-widget elementor-widget-gridxdacontactbox"
                                                        data-id="983e78f"
                                                        data-element_type="widget"
                                                        data-widget_type="gridxdacontactbox.default"
                                                    >
                                                        <div className="elementor-widget-container">
                                                            <div
                                                                data-aos="zoom-in"
                                                                className="about-contact-box-wrap"
                                                            >
                                                                <div className="about-contact-box info-box shadow-box">
                                                                    <Link
                                                                        className="overlay-link"
                                                                        to="/contact"
                                                                    ></Link>

                                                                    <img
                                                                        decoding="async"
                                                                        src="/assets/images/icon2-2.png"
                                                                        alt="Icon"
                                                                        className="star-icon"
                                                                    />

                                                                    <h1>
                                                                        Let's{' '}
                                                                        <br />
                                                                        work{' '}
                                                                        <span />
                                                                        together.
                                                                    </h1>
                                                                    <Link
                                                                        to="/contact"
                                                                        className="about-btn"
                                                                    >
                                                                        <img
                                                                            decoding="async"
                                                                            src="/assets/images/icon-2.svg"
                                                                            alt="Button"
                                                                        />
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-f093cd1"
                                                data-id="f093cd1"
                                                data-element_type="column"
                                            >
                                                <div className="elementor-widget-wrap elementor-element-populated">
                                                    <div
                                                        className="elementor-element elementor-element-ee2d870 elementor-widget elementor-widget-gridxdacredentialbox"
                                                        data-id="ee2d870"
                                                        data-element_type="widget"
                                                        data-widget_type="gridxdacredentialbox.default"
                                                    >
                                                        <div className="elementor-widget-container">
                                                            <div data-aos="zoom-in">
                                                                <div className="info-box info-box1 shadow-box h-full">
                                                                    <Link
                                                                        className="overlay-link"
                                                                        to="/credentials"
                                                                    ></Link>

                                                                    <img
                                                                        decoding="async"
                                                                        src="/assets/images/uploads/2023/04/sign.webp"
                                                                        alt="Sign"
                                                                        className='imgauto'
                                                                    />
                                                                    <div className="d-flex align-items-center justify-content-between">
                                                                        <div className="infos">
                                                                            <h4>
                                                                                MORE
                                                                                ABOUT
                                                                                ME
                                                                            </h4>
                                                                            <h1>
                                                                                Credentials
                                                                            </h1>
                                                                        </div>

                                                                        <Link
                                                                            to="/credentials"
                                                                            className="about-btn"
                                                                        >
                                                                            <img
                                                                                decoding="async"
                                                                                src="/assets/images/icon-2.svg"
                                                                                alt="Button"
                                                                            />
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </section>
    );
}

export default Service;
